import { render, staticRenderFns } from "./CertificationTypeEditor.vue?vue&type=template&id=72fffb72&scoped=true&"
import script from "./CertificationTypeEditor.vue?vue&type=script&lang=js&"
export * from "./CertificationTypeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fffb72",
  null
  
)

export default component.exports